import { useMemo, useReducer, useState, useEffect } from "react";
import { Form, Modal, Button, Alert, Row, Container, Col, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { GetHeadersOpts } from '../../App';
import PagerTable from '../../common/tables/PagerTable'
import Confirm from '../../common/widgets/Confirm'
import Select from 'react-select';



interface ListEditorProps {
    onListSaved: (close?: boolean) => void,
    getHeaders: (opts?: GetHeadersOpts) => Headers
    list: any
}

interface productOffer {
    potypeId: number;
    prodOfferId: number;
    clientId: number;
    name: string;
    isNew: boolean;
    deleted: boolean;
    lastModified: Date;
    modifiedBy: string;
    lastModifiedString: string;
    editbtn: any; // Function returning JSX
}

interface poTypesWrapper {
    count: number;
    data: productOffer[];
}

const ListEditor = (props: ListEditorProps) => {

    const { list } = props;

    const [name, setName] = useState<string>(list.name)
    const [code, setCode] = useState<string>(list.code)
    const [sortOrder, setSortOrder] = useState<string>(list.sortOrder)
    const [delmode, setDelmode] = useState(list.poTypeId === "0" ? "disabled" : ""); // possible values: disabled, blank, prompt, confirmed
    const [tableData, setTableData] = useState<any>({ count: 0, data: [], }) // current data (po type ) for table.

    const [productOffersDDL, setProductOffersDDL] = useState<any>([])
    const [refresh, doRefresh] = useReducer((d) => d + 1, 0);
    const [errors, setErrors] = useState({ name: "", })
    const [alertx, setAlertx] = useState<any>({ message: "", variant: "", showAlert: true })

    const [productOffer, setProductOffer] = useState<any>(0)

    const [selectValue, setSelectValue] = useState<any>(0)

    // all the ProductOffers, represents disconnected table
    const [dbProductOffers, setDbProductOffers] = useState<poTypesWrapper>({ count: 0, data: [], })
    // all the ProductOffers those are linked with this po type.
    const [myProductOffersFull, setMyProductOffersFull] = useState<poTypesWrapper>({ count: 0, data: [], })

    const [clientsData, setClientsData] = useState([]);
    const [selectedClientID, setSelectedClientID] = useState<string>(list.clientID);


    // FIXME... OLX still stuck on FA V4... need to update to at least 5
    let faIconClass = "fas fa-trash"



    const close = () => {
        props.onListSaved();
    }


    const onDeleteConfirm = (resp: boolean) => {
        if (resp) {
            onListSaved(); // initiate save to delete
        }
        else {
            setDelmode("") // clear confirm popup.
        }
    }


    const onListSaved = () => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/ProductOfferTypes`;

        let validationErrors = "";

        if (!name) {
            validationErrors += "Name is required. \n";
        }
        if (!code) {
            validationErrors += "Code is required. \n";
        }

       

        if (sortOrder === "") {
            validationErrors += `Sort Order is required. `;
        }

        if (validationErrors !== "") {
            setAlertx({ message: validationErrors, variant: "danger" });
            return;
        }

        const myItems = myProductOffersFull.data.filter(x => x.isNew === true || x.deleted === true);
        // ban address detail
        // form names are same as dto in this case... so just copy
        var data = {
            poTypeId: list.poTypeId,
            name: name,
            code: code,
            sortOrder: sortOrder,
            items: myItems,
            clientId: selectedClientID
        }

        fetch(_url,
            {
                method: list.poTypeId === "0" ? "POST" : delmode === "prompt" ? "DELETE" : "PUT",
                headers: props.getHeaders(),
                body: JSON.stringify(data)
            })
            .then(response => response.json())
            .then((resp: any) => {
                if (resp.success) {
                    if (list.poTypeId === "0") {
                        list.poTypeId = resp.newid;
                        setDelmode("");
                        // add... leave open so association can be added. 
                        props.onListSaved({
                            ...list,
                            poTypeId: resp.newid,
                            name: name,
                            code: code,
                            sortOrder: sortOrder
                        });

                      setAlertx({ message: "New product offer type saved successfully. Click save.", variant: "success" });
                    }
                    else props.onListSaved(); // update... close when saved
                }
                else {
                    setAlertx({ message: resp.status, variant: "danger" });
                }
                // 
            }).catch(err => { console.log(err) });

    }



    const onProductOfferChange = (selectedOption: any) => {
        setSelectValue(selectedOption);
        setProductOffer(selectedOption.value);
    };
 

    const columns = useMemo(
        () => [
            {
                Header: '',
                accessor: 'editbtn', // accessor is the "key" in the data
                maxWidth: 30
            },
            {
                Header: 'Name',
                accessor: 'name',
                minWidth: 250
            },
            {
                Header: 'Client',
                accessor: "client",
                maxWidth: 80
            }
        ],
        [list, alertx]
    )

    useEffect(() => {

        fetchOptions();

        fetchClients();
        // Return a cleanup function
        return () => {
            // Cancel any outstanding asynchronous tasks here, if applicable
        };
    }, [])



    const getData = async (pageSize: number, pageIndex: number) => {

        // Load data for Dispositions Select
        //fetchOptions();
        pageIndex = pageIndex + 1;
        const startIndex = (pageIndex - 1) * pageSize;
        const endIndex = pageIndex * pageSize;

        const productOfferSelected = JSON.parse(JSON.stringify(myProductOffersFull));

        productOfferSelected.data = productOfferSelected.data.filter((s: any) => !s.deleted).slice(startIndex, endIndex);

        productOfferSelected.data.map((d: any) => {
            d.editbtn = <i key={d.poTypeId} className={faIconClass} style={{ color: 'red' }} title="Remove association" onClick={() => { removeAssociation(d.prodOfferId); }} />
            d.lastModifiedString =
                <OverlayTrigger placement="right" overlay={<Tooltip id="tooltip"><strong>{d.lastModified ? new Date(d.lastModified).toLocaleTimeString() : ''}</strong>  </Tooltip>}>
                    <span>{d.lastModified ? new Date(d.lastModified).toLocaleDateString() : ''}</span>
                </OverlayTrigger>
        });
        setTableData(productOfferSelected);

        const dbProductOffersStringified = JSON.parse(JSON.stringify(dbProductOffers));
        const dbProductOffersStringifiedX = dbProductOffersStringified.data.map((d: any) => ({
            "value": d.prodOfferId,
            "label": d.name,
            isNew: myProductOffersFull.data.filter((x: any) => x.prodOfferId === d.prodOfferId && !x.deleted)[0],
            clientId: d.clientId
        }))
        if (selectedClientID === "0" || !selectedClientID)
            setProductOffersDDL(dbProductOffersStringifiedX.filter((x: any) => !x.isNew));
        else
            setProductOffersDDL(dbProductOffersStringifiedX.filter((x: any) => !x.isNew && x.clientId === null || x.clientId === 0 || x.clientId === parseInt(selectedClientID)));
    }


    const addAssociation = () => {

        let validationErrors = "";

        if (!name) {
            validationErrors += "Name is required. \n";
        }
        if (!code) {
            validationErrors += "Code is required. \n";
        }
        if (!productOffer || productOffer==='') {
            validationErrors += "Product Offer is required. \n";
        }
        if (sortOrder === "") {
            validationErrors += `Sort Order is required. `;
        }

        if (validationErrors !== "") {
            setAlertx({ message: validationErrors, variant: "danger" });
            return;
        }

        const newItems: any[] = [];
        // Instead of going back to DB we can get details of ProductOffers from state variable.
        // add the record of ProductOffers to table below.
        dbProductOffers.data.forEach((obj: any) => {
            if (obj.prodOfferId === productOffer) {
                // Deep clone of the state object
                const newRowObject = JSON.parse(JSON.stringify(obj));
                const newItem = {
                    prodOfferId: newRowObject.prodOfferId,
                    potypeId: newRowObject.potypeId,
                    clientId: newRowObject.clientId,
                    client: newRowObject.client,
                    name: newRowObject.name,
                    deleted: false,
                    isNew: true,
                    editbtn: <i className="fas fa-trash" style={{ color: 'red', cursor: 'pointer' }} onClick={() => removeAssociation(newRowObject.prodOfferId)} />
                };
                newItems.push(newItem);
            }
        });
         
        // if this new item does not already exists in memory add this 
        const exists = myProductOffersFull.data.filter(x => x.prodOfferId === productOffer)[0];
        if (!exists) {
            const updatedData = [...myProductOffersFull.data, newItems[0]];
            const updatedTableData = { ...myProductOffersFull, data: updatedData };
            setMyProductOffersFull(updatedTableData);
            // make a copy
            const dropdownDataUpdated = JSON.parse(JSON.stringify(dbProductOffers));
            // mark the item as Added
            dropdownDataUpdated.data.forEach(((item: any) => {
                // all the ProductOffers those are linked with this ProductOfferType
                if (item.prodOfferId === productOffer) {
                    item.isNew = true;
                }
            }));
            setDbProductOffers(dropdownDataUpdated);
            doRefresh();
        } else {
            setAlertx({ message: `This product offer is already linked.`, variant: "danger" });
        }

        setSelectValue('');
    }


    const removeAssociation = (prodOfferId: any) => {

        // make a copy
        const poTypesStringified = JSON.parse(JSON.stringify(myProductOffersFull));

        let markAsDeleted = false;
        // mark the item as deleted
        poTypesStringified.data.forEach(((item: productOffer) => {
            // all the ProductOffers those are linked with this ProductOfferType
            if (item.prodOfferId === prodOfferId) {
                item.deleted = true;
                item.lastModified = new Date();
                markAsDeleted = item.isNew; // if item is new and also marked as delete we can remove this from memory
            }
        }));
         
        if (markAsDeleted) {
            const updatedTableData = { ...myProductOffersFull, data: poTypesStringified.data.filter((x: any) => x.prodOfferId !== prodOfferId) };
            setMyProductOffersFull(updatedTableData);
        }
        else
            setMyProductOffersFull(poTypesStringified);

        doRefresh()

        // make a copy
        const dropdownDataUpdated = JSON.parse(JSON.stringify(dbProductOffers));
        // mark the item as Added
        dropdownDataUpdated.data.forEach(((item: any) => {
            // all the dispositions those are linked with this call disposition type.
            if (item.prodOfferId === prodOfferId) {
                item.isNew = false;
            }
        }));
        setDbProductOffers(dropdownDataUpdated);

        doRefresh()
    }

    const fetchOptions = (() => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/ProductOffers?page=${0}&pageSize=${100000}`;
 
        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {

                const data2 = resp.data;
                data2.forEach(((item: productOffer) => {
                    // dbProductOffers variable will hold all the ProductOffers either are linked or not 
                    // this is helpful when Add (association is called)
                    const exists = dbProductOffers.data.filter(x => x.prodOfferId === item.prodOfferId)[0];
                    if (!exists) {
                        dbProductOffers.data.push(item);
                    }
                }));

                // Format and set the data in state, I need to pass type as well to filter linked only
                const formattedData = formatData(resp.data, list.poTypeId); // Call your formatting function

                const myPoTypesFullUpdated = JSON.parse(JSON.stringify(formattedData));
                setMyProductOffersFull(myPoTypesFullUpdated);

                const myPoTypesFullUpdated2 = JSON.parse(JSON.stringify(formattedData));
                myPoTypesFullUpdated2.data = myPoTypesFullUpdated.data.slice(0, 10);

                myPoTypesFullUpdated2.data.map((d: any) => {
                    d.editbtn = <i key={d.poTypeId} className={faIconClass} style={{ color: 'red' }} title="Remove association" onClick={() => { removeAssociation(d.poTypeId); }} />
                    d.lastModified = d.lastModified ? new Date(d.lastModified).toLocaleString() : '';
                });

                doRefresh()
            }).catch(err => { console.log(err) });
    });

    const fetchClients = (() => {
        const apiBase = sessionStorage.getItem("apibase");
        var _url = `${apiBase}/v1/Clients?page=${0}&pageSize=${100000}`;

        fetch(_url,
            {
                method: "GET",
                headers: props.getHeaders(),
            })
            .then(response => response.json())
            .then((resp: any) => {
                setClientsData(resp.data)
            }).catch (err => { console.log(err) });
    });


    function formatData(rawData: any, typeId: number) {
        // Perform data formatting operations here
        let formattedData: poTypesWrapper = { data: [], count: 0 }
        formattedData.count = rawData.filter((d: any) => d.potypeId === typeId).length;
        formattedData.data = rawData.filter((d: any) => d.potypeId === typeId);
        return formattedData;
    }

    // Event handler for selecting an option
    const handleClientChange = (e: any) => {
        setSelectedClientID(e.target.value);

        const dbProductOffersFormatted = JSON.parse(JSON.stringify(dbProductOffers));;
        const productOffersX = dbProductOffersFormatted.data.map((d: any) => ({
            "value": d.prodOfferId,
            "label": d.name,
            isNew: myProductOffersFull.data.filter((x: any) => x.prodOfferId === d.prodOfferId && !x.deleted)[0],
            clientId: d.clientId
        }))
         
        if (e.target.value !== "0") {
            setProductOffersDDL(productOffersX.filter((x: any) => !x.isNew && x.clientId === null || x.clientId === 0 || x.clientId === parseInt(e.target.value)));
        } else {
            setProductOffersDDL(productOffersX.filter((x: any) => !x.isNew));
        }
    };



    return (
        <>
            <Modal show={true} onHide={close} size="lg" >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {/*     <img src={require('/dotnetoms/Images/menu/headset.png')} />*/}
                        Product Offer Type</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Container>
                        <Row>
                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={2}>
                                    Name
                                </Form.Label>
                                <Col sm={6}>
                                    <Form.Control placeholder="Name" value={name} required
                                        onChange={(e: any) => setName(e.target.value)} />
                                </Col>
                                <Form.Label column sm={1}>
                                    Code
                                </Form.Label>
                                <Col sm={3}>
                                    <Form.Control placeholder="Code" value={code} required
                                        onChange={(e: any) => setCode(e.target.value)} />

                                </Col>
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={2}>
                                    Client
                                </Form.Label>
                                <Col sm={6}>
                                    <Form.Select value={selectedClientID} disabled={JSON.parse(JSON.stringify(myProductOffersFull)).data.filter((s: any) => !s.deleted).length > 0}
                                        onChange={handleClientChange}  >
                                        <option value="0">None</option>
                                        {clientsData.map((i: any) => (
                                            <option key={i.clientId} value={i.clientId}>
                                                {i.client}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Form.Label column sm={1}>
                                    Sort Order
                                </Form.Label>
                                <Col sm={3}>
                                    <Form.Control placeholder="Sort Order" value={sortOrder} required
                                        onChange={(e: any) => setSortOrder(e.target.value)} />
                                </Col>
                            </Form.Group>
                        </Row>

                        <Row>
                            <Form.Group as={Row} className="mb-4" controlId="formHorizontalEmail">
                                <Form.Label column sm={2}>
                                    Product Offers
                                </Form.Label>
                                <Col sm={6}>
                                    <Select options={productOffersDDL} value={selectValue} onChange={onProductOfferChange} placeholder={"Select Product Offer"} onFocus={() => setAlertx({ showAlert: true })} />

                                </Col>
                              
                                <Col sm={4}>
                                    <Button className="ms-1 float-start" variant="primary" onClick={addAssociation}  >
                                        <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/add2.png")`, "marginRight": "5px" }} ></i>
                                        Add</Button>
                                </Col>
                            </Form.Group>
                        </Row>
                      
                        {(errors.name) ? <span className="valerror" >{errors.name}</span> : null}
                        <br />
                    </Container>
                    
                    
                   
                    <PagerTable getData={getData} columns={columns} tableData={tableData} refresh={refresh} />


                    {/* Show Delete confirm if called */}
                    {delmode !== "prompt" ? null :
                        <Confirm onResponse={onDeleteConfirm} onClose={() => setDelmode("")}
                            headerText="Delete"
                            bodyText="Are you sure you want to delete this?"
                        />
                    }

                </Modal.Body>
                <Modal.Footer>
                    {alertx.message ? <div className="w-100"><Alert variant={alertx.variant} show={alertx.showAlert} onClose={() => setAlertx({ showAlert: true })} dismissible >{alertx.message}</Alert></div> : null}
                    <div className="w-100">
                        <Button onClick={onListSaved} variant="primary" className="ms-1" >
                            <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/disk_blue.png")`, "marginRight": "5px" }} ></i>
                            Save
                        </Button>
                        <Button variant="secondary" className="ms-1" onClick={close}>
                            <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/undo.png")`, "marginRight": "5px" }} ></i>

                            Cancel</Button>
                        {delmode !== "disabled" ? <Button variant="danger" className="float-end" onClick={() => setDelmode("prompt")}>
                            <i className="rbPrimaryIcon-custom" style={{ backgroundImage: `url("images/16/delete.png")`, "marginRight": "5px" }} ></i>

                            Delete</Button> : null}
                    </div>

                    <div className="w-100" style={{ fontSize: 12 }} >
                        <p>Created: {list.createdDttm ? new Date(list.createdDttm).toLocaleString() : ''} {list.createdBy ? 'by' : ''}  {list.createdBy}  <br />
                            Modified: {list.modifiedDttm ? new Date(list.modifiedDttm).toLocaleString() : ''} {list.modifiedBy ? 'by' : ''} {list.modifiedBy}</p>
                    </div>
                </Modal.Footer>
            </Modal>
        </>)
}

export default ListEditor;


